import { format } from 'date-fns/esm';
import { Box, Card, Typography } from '@mui/material';

import { QuillViewer } from 'components/QuillEditor';
import { IPatientInfo } from 'apis/admin/type';
import { subtleScrollbarSx } from 'styles/subtleScrollbar';

interface Props {
  patientInfo: IPatientInfo;
}

const MedicalNote = ({ patientInfo }: Props) => {
  const today = format(new Date(), 'yyyy-MM-dd');
  const rawNote = patientInfo.medical_note ?? '';

  return (
    <Box
      flex={1.2}
      display="flex"
      flexDirection="column"
      overflow="auto"
      height="100%"
      sx={subtleScrollbarSx}
    >
      <Card
        component="section"
        sx={{
          p: '12px 15px',
          height: '100%',
          overflow: 'auto',
          ...subtleScrollbarSx,
        }}
      >
        <Typography variant="subtitle2" fontSize={13} mb={1}>
          환자상황 및 처방내역
        </Typography>
        <Typography variant="caption" component="p" color="#00000080" mb={1}>
          처방일시 {today}
        </Typography>
        <QuillViewer content={rawNote} />
      </Card>
    </Box>
  );
};

export default MedicalNote;
